import React from 'react';
import Modal from 'react-modal';
import { Button } from './Button';
import { ReactComponent as CloseIcon } from '../assets/icons/x.svg';
import { Image } from '../types';

interface ImagePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  image: Image | null;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  onClose,
  image,
}) => {
  if (!image) return null;

  return (
    <Modal
      className="modal-content md:max-w-[800px]"
      overlayClassName="modal-overlay"
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Image Preview"
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div>
          <h2 className="text-primary font-medium text-xl">Image Preview</h2>
          <p className="text-sm text-gray-500">{image.title}</p>
        </div>
        <Button onClick={onClose} variant="icon">
          <CloseIcon className="w-3 h-3" />
        </Button>
      </div>

      {/* Image */}
      <div className="flex items-center justify-center bg-gray-100 rounded-lg p-4 min-h-[300px]">
        <img
          src={image.url}
          alt={image.title}
          className="max-w-full max-h-[60vh] object-contain rounded"
        />
      </div>

      {/* Image Info */}
      <div className="mt-4 flex gap-4 text-sm text-gray-500">
        {image.width && image.height && (
          <span>
            Dimensions: {image.width} × {image.height}px
          </span>
        )}
        {image.contentType && <span>Type: {image.contentType}</span>}
      </div>

      {/* Actions */}
      <div className="flex justify-end mt-4">
        <Button type="button" variant="outline" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};
